<template>
  <v-autocomplete
    outlined
    hide-details
    clearable
    return-object
    no-filter
    hide-selected
    hide-no-data
    item-text="pessoa.nome"
    :label="label"
    v-model="localValue"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    @blur="onBlur"
    @focus="onFocus"
    v-bind="$attrs"
  >
    <template v-slot:item="item">
      <slot name="item" v-bind:item="item">
        <v-list-item-content>
          <v-list-item-title>
            <px-chip-codigo-interno :codigo-interno="item.item.codigoInterno"/>
            {{ item.item.pessoa.nome }}
          </v-list-item-title>
        </v-list-item-content>
      </slot>
    </template>
    <template v-slot:selection="item">
      <div>
        <px-chip-codigo-interno :codigo-interno="item.item.codigoInterno"/>
        <span>{{ item.item.pessoa.nome }}</span>
      </div>
    </template>
  </v-autocomplete>
</template>

<script>
import { debounce } from 'vuetify/lib/util/helpers';
import CompradorService from '@/api/comprador-service';

const DEFAULT_LIMIT = 30;
const DEFAULT_OFFSET = 0;

export default {
  props: {
    value: Object,
    label: {
      type: String,
      default: 'Empresa',
    },
  },
  data() {
    return {
      loading: false,
      items: [],
      model: null,
      search: null,
      debounceSearch: null,
    };
  },
  computed: {
    localValue: {
      get() { return this.value; },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  watch: {
    search(val) {
      if (!val || (this.localValue && this.localValue.pessoa.nome === val)) return;
      this.debounceSearch(val);
    },
    value() {
      if (this.value) {
        this.items = [this.value, ...this.items];
      }
    },
  },
  methods: {
    seachCompradores(val) {
      const searchValue = val || '';

      const searchTerm = searchValue.toLowerCase();

      this.loading = true;
      CompradorService.getCompradorPage({
        limit: DEFAULT_LIMIT,
        offset: DEFAULT_OFFSET,
        query: `nome like "%${searchTerm}%" or cnpj like "%${searchTerm}%" or codigoInterno like "%${searchTerm}%" order by nome`,
      })
        .then((response) => {
          this.items = this.value ? [this.value, ...response.data.content] : response.data.content;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onBlur(event) {
      this.$emit('blur', event);
    },
    onFocus() {
    },
  },
  created() {
    this.debounceSearch = debounce(this.seachCompradores, 1000);
    if (this.value) {
      this.items = [this.value, ...this.items];
    }
  },
};
</script>
